import { Component, Input } from '@angular/core';
import { ImageCroppedEvent } from 'ngx-image-cropper';

@Component({
  selector: 'app-imageupload',
  templateUrl: './imageupload.component.html',
  styleUrl: './imageupload.component.css'
})
export class ImageuploadComponent {
  fileUploadedtoggle: boolean;
  imageChangedEvent: any = '';
  croppedImage: any = '';
  cropperready: boolean;
  selectedFiles: FileList;
  selectedFileName: string;
  @Input() filename: string;
  @Input() imagewidth: number;
  @Input() aspect: string;

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
    this.selectedFiles = event.target.files;
    this.selectedFileName = this.selectedFiles.item(0).name;
  }
  imageCropped(event: ImageCroppedEvent) {
    //console.log(event);
    this.croppedImage = event.base64;
  }
  cropperReady() {
    // cropper ready
    this.cropperready = true;
  }
  loadImageFailed() {
    // show message
  }
  base64ToFile(data, filename) {

    const arr = data.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    let u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  logoreset() {
    this.cropperready = false;
    this.selectedFiles = null;
    this.imageChangedEvent = null;
  }

  saveimage() {

  }
}
